'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _iBem = require('../../i-bem/i-bem.react');

exports.default = (0, _iBem.decl)({
    block: 'header2',
    elem: 'left'
});